import { render, staticRenderFns } from "./testScore.vue?vue&type=template&id=4a5cd525&scoped=true&"
import script from "./testScore.vue?vue&type=script&lang=js&"
export * from "./testScore.vue?vue&type=script&lang=js&"
import style0 from "./testScore.vue?vue&type=style&index=0&id=4a5cd525&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5cd525",
  null
  
)

export default component.exports